// @flow

import {createContext} from 'react';

export type DataTableHeaderContextType = {
    isSticky: boolean,
};

export const DataTableHeaderContext: React$Context<DataTableHeaderContextType> =
    createContext<DataTableHeaderContextType>({
        isSticky: false,
    });

DataTableHeaderContext.displayName = 'DataTableHeaderContext';
